(()=>{
  const instances=new WeakMap();
  function init(root=document){
    const heroes=[...(root.matches?.('.lux-hero')?[root]:[]),...root.querySelectorAll('.lux-hero')];
    heroes.forEach(hero=>{
      if(instances.has(hero))return;
      const slides=[...hero.querySelectorAll('.lux-slide')],dots=[...hero.querySelectorAll('[data-slide]')];
      if(!slides.length)return;
      const abort=new AbortController(),options={signal:abort.signal};
      const reduce=matchMedia('(prefers-reduced-motion: reduce)'),pause=hero.querySelector('.lux-pause');
      let index=0,timer,paused=false,selected=false;
      const interval=Math.max(3000,Math.min(10000,Number(hero.dataset.interval)||5000));
      function stop(){clearInterval(timer)}
      function start(){
        stop();
        if(slides.length>1&&hero.dataset.autoplay!=='false'&&!paused&&!selected&&!reduce.matches&&!document.hidden&&!hero.matches(':hover')&&!hero.contains(document.activeElement))timer=setInterval(()=>show(index+1),interval);
      }
      function show(n){
        index=(n+slides.length)%slides.length;
        slides.forEach((slide,i)=>{
          const active=i===index;
          slide.classList.toggle('active',active);
          slide.setAttribute('aria-hidden',String(!active));
          slide.inert=!active;
          slide.querySelectorAll('a').forEach(a=>a.tabIndex=active?0:-1);
        });
        dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
      }
      dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.slide));start()},options));
      hero.querySelector('.lux-prev')?.addEventListener('click',()=>{show(index-1);start()},options);
      hero.querySelector('.lux-next')?.addEventListener('click',()=>{show(index+1);start()},options);
      pause?.addEventListener('click',()=>{
        paused=!paused;
        pause.setAttribute('aria-pressed',String(paused));
        pause.setAttribute('aria-label',paused?pause.dataset.playLabel:pause.dataset.pauseLabel);
        pause.textContent=paused?'▶':'Ⅱ';
        start();
      },options);
      hero.addEventListener('mouseenter',stop,options);
      hero.addEventListener('mouseleave',start,options);
      hero.addEventListener('focusin',stop,options);
      hero.addEventListener('focusout',()=>queueMicrotask(start),options);
      document.addEventListener('visibilitychange',start,options);
      reduce.addEventListener('change',start,options);
      hero.addEventListener('keydown',e=>{
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
          e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1));start();
        }
      },options);
      hero.addEventListener('shopify:block:select',e=>{
        const slide=e.target.closest('.lux-slide');
        if(slide&&slides.includes(slide)){selected=true;stop();show(slides.indexOf(slide))}
      },options);
      hero.addEventListener('shopify:block:deselect',()=>{selected=false;start()},options);
      const controls=hero.querySelector('.lux-slide-controls');
      if(controls)controls.hidden=slides.length<2;
      instances.set(hero,()=>{stop();abort.abort();instances.delete(hero)});
      show(0);start();
    });
  }
  init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.lux-hero').forEach(hero=>instances.get(hero)?.()));
})();
